import React from 'react';
import PropTypes from 'prop-types';

import WebGlModalComponent from '../components/webgl-modal/webgl-modal.jsx';

class WebGlModal extends React.Component {
    constructor (props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
    }
    handleCancel () {
        window.history.back();
    }
    handleContinue () {
        if (typeof window !== 'undefined') {
            sessionStorage.setItem('dismissWebGlModal', 'true');
            localStorage.setItem('dismissWebGlModal', 'true');
        }
        if (this.props.onDismiss) {
            this.props.onDismiss();
        }
    }
    render () {
        return (
            <WebGlModalComponent
                isRtl={this.props.isRtl}
                onBack={this.handleCancel}
                onContinue={this.handleContinue}
            />
        );
    }
}

WebGlModal.propTypes = {
    isRtl: PropTypes.bool,
    onDismiss: PropTypes.func
};

export default WebGlModal;
